'use strict';

// Intl for IE11 and older
(typeof Intl !== 'function') && require('intl');

// override react-i18n default loader (forklifter), which doesn't support caching
var ReactI18n = require('react-i18n');
var loader = require('./TemplateLoader');

module.exports = ReactI18n.createi18n(loader, ReactI18n.user.getLocale());



// WEBPACK FOOTER //
// ./public/js/utils/i18n.js